
/**
 * Eine Untermenge von Object3D, nur Aspekte des Koordinatensystems.
 */
export default class CoordinateSystem {

    position = new THREE.Vector3(0, 0, 0);
    quaternion = new THREE.Quaternion();
    scale = new THREE.Vector3( 1, 1, 1 );

    clone() {
        const clone = new CoordinateSystem();
        clone.position = this.position.clone();
        clone.quaternion = this.quaternion.clone();
        clone.scale = this.scale.clone();
        return clone;
    }

    static copyAtoB(a,b) {
        b.position.copy(a.position);
        b.quaternion.copy(a.quaternion);
        b.scale.copy(a.scale);
    }

    from(object) {
        CoordinateSystem.copyAtoB(object,this);
        return this;
    }

    to(object) {
        CoordinateSystem.copyAtoB(this,object);
        return this;
    }

    getMatrix() {
        const matrix = new THREE.Matrix4();

        matrix.multiply(new THREE.Matrix4().scale( this.scale ));
        matrix.multiply(new THREE.Matrix4().makeRotationFromQuaternion( this.quaternion ));
        matrix.multiply(new THREE.Matrix4().setPosition( this.position ));

        // matrix.compose( this.position, this.quaternion, this.scale );
        return matrix;
    }

    /**
     * @param {CoordinateSystem} other
     * @param {number} [epsilon=0.01]
     */
    sufficientEqual(other, epsilon=0.01){
        return this.position.clone().sub(other.position).length()<epsilon && this.scale.equals(other.scale) && this.quaternion.isCloseTo(other.quaternion,epsilon);
    }

    /**
     * @returns {(THREE.Ray)}
     */
    getInverseRayMapper() {
        const inverseMatrix = new THREE.Matrix4();
        inverseMatrix.copy( this.getMatrix() ).invert();
        const localRay = new THREE.Ray();
        return ray => localRay.copy( ray ).applyMatrix4( inverseMatrix );
    }

}
